import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getDirectlyUnderBindPage,
  getDirectlyUnderBindAll,
  getRootVehicleInfoGroups,
  getChildrenGroups,
  getClientBindVehicleInfoGroupsPage,
  bindVehicleInfoGroupsToUser,
  unBindUserVehicleInfoGroups,
  bindForwardlyNoticeUsers,
  unBindForwardlyNoticeUsers,
  batchAddBusinessNotes,
  myBatchAddBusinessNotes
} from '@/api/vehicleinfogroupserv'

export default {
  state: {
    state_VehicleInfoGroup_AddObjResult: null,
    state_VehicleInfoGroup_GetAllResult: null,
    state_VehicleInfoGroup_SearchByNameResult: null,
    state_VehicleInfoGroup_GetPageResult: null,
    state_VehicleInfoGroup_GetDetailResult: null,
    state_VehicleInfoGroup_ModifyObjResult: null,
    state_VehicleInfoGroup_DeleteObjResult: null,
    state_VehicleInfoGroup_GetDirectlyUnderBindPageResult: null,
    state_VehicleInfoGroup_GetDirectlyUnderBindAllResult: null,
    state_VehicleInfoGroup_GetRootVehicleInfoGroupsResult: null,
    state_VehicleInfoGroup_GetChildrenGroupsResult: null,
    state_VehicleInfoGroup_GetClientBindVehicleInfoGroupsPageResult: null,
    state_VehicleInfoGroup_BindVehicleInfoGroupsToUserResult: null,
    state_VehicleInfoGroup_UnBindUserVehicleInfoGroupsResult: null,
    state_VehicleInfoGroup_BindForwardlyNoticeUsersResult: null,
    state_VehicleInfoGroup_UnBindForwardlyNoticeUsersResult: null,
    state_VehicleInfoGroup_BatchAddBusinessNotesResult: null,
    state_VehicleInfoGroup_MyBatchAddBusinessNotesResult: null
  },
  mutations: {
    SET_VEHICLEINFOGROUP_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_AddObjResult = rst
    },
    SET_VEHICLEINFOGROUP_GETALL_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetAllResult = rst
    },
    SET_VEHICLEINFOGROUP_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_SearchByNameResult = rst
    },
    SET_VEHICLEINFOGROUP_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetPageResult = rst
    },
    SET_VEHICLEINFOGROUP_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetDetailResult = rst
    },
    SET_VEHICLEINFOGROUP_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_ModifyObjResult = rst
    },
    SET_VEHICLEINFOGROUP_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_DeleteObjResult = rst
    },
    SET_VEHICLEINFOGROUP_GETDIRECTLYUNDERBINDPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetDirectlyUnderBindPageResult = rst
    },
    SET_VEHICLEINFOGROUP_GETDIRECTLYUNDERBINDALL_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetDirectlyUnderBindAllResult = rst
    },
    SET_VEHICLEINFOGROUP_GETROOTVEHICLEINFOGROUPS_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetRootVehicleInfoGroupsResult = rst
    },
    SET_VEHICLEINFOGROUP_GETCHILDRENGROUPS_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetChildrenGroupsResult = rst
    },
    SET_VEHICLEINFOGROUP_GETCLIENTBINDVEHICLEINFOGROUPSPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_GetClientBindVehicleInfoGroupsPageResult = rst
    },
    SET_VEHICLEINFOGROUP_BINDVEHICLEINFOGROUPSTOUSER_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_BindVehicleInfoGroupsToUserResult = rst
    },
    SET_VEHICLEINFOGROUP_UNBINDUSERVEHICLEINFOGROUPS_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_UnBindUserVehicleInfoGroupsResult = rst
    },
    SET_VEHICLEINFOGROUP_BINDFORWARDLYNOTICEUSERS_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_BindForwardlyNoticeUsersResult = rst
    },
    SET_VEHICLEINFOGROUP_UNBINDFORWARDLYNOTICEUSERS_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_UnBindForwardlyNoticeUsersResult = rst
    },
    SET_VEHICLEINFOGROUP_BATCHADDBUSINESSNOTES_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_BatchAddBusinessNotesResult = rst
    },
    SET_VEHICLEINFOGROUP_MYBATCHADDBUSINESSNOTES_RESULT: (state, rst) => {
      state.state_VehicleInfoGroup_MyBatchAddBusinessNotesResult = rst
    }
  },
  actions: {
    VehicleInfoGroupServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetDirectlyUnderBindPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDirectlyUnderBindPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETDIRECTLYUNDERBINDPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETDIRECTLYUNDERBINDPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetDirectlyUnderBindAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDirectlyUnderBindAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETDIRECTLYUNDERBINDALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETDIRECTLYUNDERBINDALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetRootVehicleInfoGroups ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getRootVehicleInfoGroups(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETROOTVEHICLEINFOGROUPS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETROOTVEHICLEINFOGROUPS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetChildrenGroups ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getChildrenGroups(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETCHILDRENGROUPS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETCHILDRENGROUPS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_GetClientBindVehicleInfoGroupsPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getClientBindVehicleInfoGroupsPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_GETCLIENTBINDVEHICLEINFOGROUPSPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_GETCLIENTBINDVEHICLEINFOGROUPSPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_BindVehicleInfoGroupsToUser ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindVehicleInfoGroupsToUser(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_BINDVEHICLEINFOGROUPSTOUSER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_BINDVEHICLEINFOGROUPSTOUSER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_UnBindUserVehicleInfoGroups ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        unBindUserVehicleInfoGroups(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_UNBINDUSERVEHICLEINFOGROUPS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_UNBINDUSERVEHICLEINFOGROUPS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_BindForwardlyNoticeUsers ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindForwardlyNoticeUsers(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_BINDFORWARDLYNOTICEUSERS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_BINDFORWARDLYNOTICEUSERS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_UnBindForwardlyNoticeUsers ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        unBindForwardlyNoticeUsers(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_UNBINDFORWARDLYNOTICEUSERS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_UNBINDFORWARDLYNOTICEUSERS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_BatchAddBusinessNotes ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchAddBusinessNotes(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_BATCHADDBUSINESSNOTES_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_BATCHADDBUSINESSNOTES_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleInfoGroupServ_MyBatchAddBusinessNotes ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        myBatchAddBusinessNotes(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFOGROUP_MYBATCHADDBUSINESSNOTES_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEINFOGROUP_MYBATCHADDBUSINESSNOTES_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_VehicleInfoGroup_AddObjResult: state => {
      return state.state_VehicleInfoGroup_AddObjResult
    },
    get_VehicleInfoGroup_GetAllResult: state => {
      return state.state_VehicleInfoGroup_GetAllResult
    },
    get_VehicleInfoGroup_SearchByNameResult: state => {
      return state.state_VehicleInfoGroup_SearchByNameResult
    },
    get_VehicleInfoGroup_GetPageResult: state => {
      return state.state_VehicleInfoGroup_GetPageResult
    },
    get_VehicleInfoGroup_GetDetailResult: state => {
      return state.state_VehicleInfoGroup_GetDetailResult
    },
    get_VehicleInfoGroup_ModifyObjResult: state => {
      return state.state_VehicleInfoGroup_ModifyObjResult
    },
    get_VehicleInfoGroup_DeleteObjResult: state => {
      return state.state_VehicleInfoGroup_DeleteObjResult
    },
    get_VehicleInfoGroup_GetDirectlyUnderBindPageResult: state => {
      return state.state_VehicleInfoGroup_GetDirectlyUnderBindPageResult
    },
    get_VehicleInfoGroup_GetDirectlyUnderBindAllResult: state => {
      return state.state_VehicleInfoGroup_GetDirectlyUnderBindAllResult
    },
    get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult: state => {
      return state.state_VehicleInfoGroup_GetRootVehicleInfoGroupsResult
    },
    get_VehicleInfoGroup_GetChildrenGroupsResult: state => {
      return state.state_VehicleInfoGroup_GetChildrenGroupsResult
    },
    get_VehicleInfoGroup_GetClientBindVehicleInfoGroupsPageResult: state => {
      return state.state_VehicleInfoGroup_GetClientBindVehicleInfoGroupsPageResult
    },
    get_VehicleInfoGroup_BindVehicleInfoGroupsToUserResult: state => {
      return state.state_VehicleInfoGroup_BindVehicleInfoGroupsToUserResult
    },
    get_VehicleInfoGroup_UnBindUserVehicleInfoGroupsResult: state => {
      return state.state_VehicleInfoGroup_UnBindUserVehicleInfoGroupsResult
    },
    get_VehicleInfoGroup_BindForwardlyNoticeUsersResult: state => {
      return state.state_VehicleInfoGroup_BindForwardlyNoticeUsersResult
    },
    get_VehicleInfoGroup_UnBindForwardlyNoticeUsersResult: state => {
      return state.state_VehicleInfoGroup_UnBindForwardlyNoticeUsersResult
    },
    get_VehicleInfoGroup_BatchAddBusinessNotesResult: state => {
      return state.state_VehicleInfoGroup_BatchAddBusinessNotesResult
    },
    get_VehicleInfoGroup_MyBatchAddBusinessNotesResult: state => {
      return state.state_VehicleInfoGroup_MyBatchAddBusinessNotesResult
    }
  }
}
